module.exports = __webpack_public_path__ + "files/zahar.fd6fdc204e01b9774624356efa961596.pdf";